<template>
  <div class="options-container" :class="{bigScreen: isBigScreen}">
    <div class="slider-active" :style="{width: 'calc((100% - 6px)/ ' + options.length +')', transform: 'translate('+sliderDistance+', 0)'}"></div>
    <template v-if="useToolTip">
      <el-tooltip
        v-for="(item, index) in options"
        :key="index"
        effect="dark"
        :content="item.tip || item.label"
        placement="top-end"
        :open-delay="1000"
      >
        <span
          :key="index"
          class="options-item"
          :class="[item.value === value ? 'selected' : '', item.disabled ? 'disabled' : '', isBigScreen ? 'bigScreen' : '']"
          @click="changeOption(item.value, index, item.disabled)"
        >
          <i :class="item.icon" v-if="item.icon" class="options-item-icon"></i>
          <span v-else class="options-item-label">{{ item.label }}</span>
        </span>
      </el-tooltip>
    </template>
    <template v-else>
      <span
        v-for="(item, index) in options"
        :key="index"
        class="options-item"
        :class="[item.value === value ? 'selected' : '', item.disabled ? 'disabled' : '', isBigScreen ? 'bigScreen' : '']"
        @click="changeOption(item.value, index, item.disabled)"
      >
        <i :class="item.icon" v-if="item.icon" class="options-item-icon"></i>
        <span v-else class="options-item-label">{{ item.label }}</span>
      </span>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    useToolTip: true,
    options: {
      type: Array
    },
    useToolTip: {
      type: Boolean,
      default: false
    },
    onSelect: Function
  },
  computed: {
    activeIndex() {
      return this.options.findIndex(item => item.value === this.value)
    },
    sliderDistance() {
      return this.activeIndex === -1 ? '-110%' : (100 * this.activeIndex + '%')
    },
    isBigScreen() {
      return this.request_prefix === "bigScreen"
    }
  },
  methods: {
    changeOption(value, index, disabled) {
      if(disabled) {
        return
      }
      if (this.onSelect) {
        this.onSelect(value, value === this.value ? true : false, index)
      } else {
        this.$emit("update:value", value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
}
.bigScreen .slider-active {
  background: #575C66;
}
.slider-active {
  display: block;
  height: 24px;
  position: absolute;
  top: 3px;
  background: var(--leftMenuBgColor);
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  transition: transform 0.3s cubic-bezier(.645,.045,.355,1);
}
.options-container {
  display: flex;
  position: relative;
  width: 100%;
  height: 30px;
  padding: 3px;
  border-radius: 4px;
  box-sizing: border-box;
  user-select: none;
  background: var(--inputBackGround);
}
.options-item {
  position: relative;
  display: inline-block;
  /* width: 52px; */
  height: 24px;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
  color: var(--thirdTextColor);
  vertical-align: top;
  flex: 1;
  &.selected {
    border-radius: 3px;
    color: var(--themeColor) !important;
    &::after {
      display: none;
    }
    & + span.options-item {
      &::after {
        display: none;
      }
    }
    .options-item-icon::before {
      color: var(--themeColor) !important;
    }
  }
  &.bigScreen.selected {
    color: #fff !important;
    .options-item-icon::before {
      color: #fff !important;
    }
  }
  &:not(:first-of-type)::after {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 1px;
    height: 14px;
    background: var(--borderColorSeven);
  }
  &.disabled {
    color: var(--fourthTextColor);
    cursor: not-allowed;
  }
}
.options-item-icon {
  font-size: 16px;
  line-height: 24px;
}
</style>
